import { useState, type FormEvent } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Box, Button, TextField, Typography } from '@mui/material'
import { fetchFormCode, FORM_CODE_QUERY_KEY, saveFormCode } from '../api/descriptionPdf'
import { t } from '../i18n'

/** s62 / P3: codigo do formulario do PDF no SGQ da empresa (padrao PES.001). So quem altera a empresa edita. */
export function FormCodeField({ pode }: { pode: boolean }) {
  const qc = useQueryClient()
  const q = useQuery({ queryKey: FORM_CODE_QUERY_KEY, queryFn: fetchFormCode, retry: false })
  const [editando, setEditando] = useState(false)
  const [texto, setTexto] = useState('')
  const m = useMutation({
    mutationFn: (c: string | null) => saveFormCode(c),
    onSuccess: (r) => {
      qc.setQueryData(FORM_CODE_QUERY_KEY, r)
      setEditando(false)
    },
  })
  if (!q.isSuccess) return null
  if (!editando)
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="caption" color="text.secondary" data-testid="codigo-formulario">
          {t.descriptionPdf.formCode(q.data.formCode)}
        </Typography>
        {pode && (
          <Button
            size="small"
            onClick={() => {
              setTexto(q.data.formCode)
              setEditando(true)
            }}
          >
            {t.descriptionPdf.changeFormCode}
          </Button>
        )}
      </Box>
    )
  return (
    <Box
      component="form"
      onSubmit={(e: FormEvent) => {
        e.preventDefault()
        m.mutate(texto.trim() === '' ? null : texto.trim())
      }}
      sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
    >
      <TextField
        size="small"
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        slotProps={{ htmlInput: { maxLength: 32, 'aria-label': t.descriptionPdf.formCodeLabel } }}
        helperText={m.isError ? t.descriptionPdf.formCodeInvalid : t.descriptionPdf.formCodeHint}
        error={m.isError}
      />
      <Button type="submit" size="small" variant="outlined" disabled={m.isPending}>
        {t.descriptionPdf.save}
      </Button>
      <Button size="small" onClick={() => setEditando(false)}>
        {t.descriptionPdf.cancel}
      </Button>
    </Box>
  )
}
